import React, {Component} from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import $ from 'jquery';

import Registry from '../../../registry/index';
import NotEnoughTokensPopup from '../NotEnoughTokensPopup/index';

class CameraAccess extends Component {

	constructor(props) {
		super(props);

		this.state = {
			stateCameraAccess: null,
			cameraPermissionHelpShown: new Cookies().get('cameraPermissionHelpShown') === 'true',
			isEdge: /Edge/.test(navigator.userAgent) ? 'Edge' : null,
			isSafari: $('html').hasClass('safari') ? 'Safari' : null,
			isOpera: navigator.userAgent.match(/Opera|OPR\//) ? 'Opera' : null,
			isFirefox: /Firefox/.test(navigator.userAgent) ? 'Firefox' : null,
			isChrome: /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)  ? 'Chrome' : null
		};

	}

	setStateCamera(streamingStatus) {
		const  { isEdge, isSafari }  = this.state;
		const checkOtherPopup = $('.overlay').attr('refcount') == 0;

		if(!checkOtherPopup || isEdge || isSafari) return false;

		const { status, stream } = streamingStatus;
		const stateCameraAccess = !stream ? (status !== 'error' ? 'middle' : false) : true;

		this.state.stateCameraAccess !== stateCameraAccess ? this.setState({stateCameraAccess: stateCameraAccess}) : false;
	}

	componentDidMount() {
		setTimeout(() => this.setStateCamera(this.props.streamingStatus), 5000);
	}

	componentWillUpdate(nextProps, nextState) {
		this.setStateCamera(nextProps.streamingStatus);
	}

	closeCameraAccess() {
		this.setCookie();
		this.setLocalStorage();
		this.setState({
			stateCameraAccess: null,
			cameraPermissionHelpShown: true
		});
	}

	setCookie() {
		let date = new Date();
		let day = 24*60*30*1000;
		let cookies = new Cookies();

		date.setTime(date.getTime() + day);

		cookies.set('cameraPermissionHelpShown', true, {path: "/", expires: date});
	}
	
	setLocalStorage() {
		const counter = Number(window.localStorage.getItem('cameraPopupCounter')) || 0;
		window.localStorage.setItem('cameraPopupCounter', counter + 1);
	}

	render() {
		let {
			isEdge,
			isOpera,
			isSafari,
			isChrome,
			isFirefox,
			stateCameraAccess,
			cameraPermissionHelpShown
		} = this.state;

		if(stateCameraAccess === null) return false;

		let browserType = isOpera ? isOpera : isChrome || isFirefox;

		let lang = Registry.get('locale');

		const statusAllow = stateCameraAccess === true;
		const statusMiddle = stateCameraAccess === 'middle';
		const statusBlocked = stateCameraAccess === false;
		const statusLoading = !statusAllow && !statusMiddle && !statusBlocked;

		if(statusLoading) return false;

		cameraPermissionHelpShown = statusBlocked ? cameraPermissionHelpShown : false;

		if(statusAllow || cameraPermissionHelpShown) return false;
		const counter = Number(window.localStorage.getItem('cameraPopupCounter')) || 0;
		if (counter >= 3) return false;
		return (
			<div className={`camera-access ${browserType} ${statusMiddle ? 'middle' : ''} ${statusBlocked ? 'blocked' : ''}`} ref={el => this.cameraPage = el}>
				<div className="camera-access-left">
					<div className="arrow-left"/>
					<div className="arrow-text">
						<span className="text-notheme">{lang.click} </span>
						<span className="text-theme">{lang.allow}</span>
					</div>
				</div>
				<div className="camera-access-right">
					<div className="arrow-right"/>
					<div className="arrow-text">
						<span className="text-notheme">{lang.camera_access_right_notheme(!statusMiddle)}</span>
						<div className="ic_camera-access"/>
						<span className="text-theme">{lang.camera_access_right_theme}</span>
					</div>
				</div>
				<div className="camera-access-lighting"/>
				<div className="camera-access-girl"/>
				<a className="camera-access-close" onClick={() => this.closeCameraAccess()}>{lang.close}</a>
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        streamingStatus: state.streamingStatus,
    }
}

export default connect(mapStateToProps)(CameraAccess);



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/CameraAccess/index.js